import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SESSION_URLS } from "../../api/AdminUrls";
import { post } from "../../services/smartApiService";
import { SdsDtChangeDateFormatTimeZone } from "soft_digi/dist/services/DateService";

interface CertificateData {
  ename: string;
  course_name: string;
  course_code: string;
  from_date: string;
  to_date: string;
  certificate_no?: string;
  location?: string;
}

const CertificateVerify: React.FC = () => {
  const { encryptedId } = useParams<{ encryptedId: string }>();
  const [data, setData] = useState<any | null>(null);
  const [status, setStatus] = useState<"loading" | "verified" | "invalid">(
    "loading"
  );

  useEffect(() => {
    if (!encryptedId) {
      setStatus("invalid");
      return;
    }
    const subscription = post(
      SESSION_URLS.VERIFY_CERTIFICATE,
      { cert_id: encryptedId },
      { requiresAuthorization: false, showLoading: false }
    ).subscribe({
      next: (response: any) => {
        if (response?.data) {
          setData(response.data);
          setStatus("verified");
        } else {
          setStatus("invalid");
        }
      },
      error: () => setStatus("invalid"),
    });
    return () => subscription.unsubscribe();
  }, [encryptedId]);

  return (
    <div className="certificate-verify-page" style={{ minHeight: "100vh", backgroundColor: "#f5f7fa" }}>
      {/* Header */}
      <div
        className="has-text-centered py-4 px-4"
        style={{ backgroundColor: "white", color: "#1a3a6b" }}
      >
        <p className=" open-portel-heading " style={{ lineHeight: "1.4" }}>
      HBL Assessment 
        </p>
      </div>

      {/* Breadcrumb */}


      {/* Content */}
      <div className="container  p-0" style={{ maxWidth: "600px" }}>
        {status === "loading" && (
          <div className="has-text-centered py-6">
            <span className="icon is-large has-text-info">
              <i className="fa fa-spinner fa-spin fa-2x" />
            </span>
            <p className="mt-3 has-text-grey">Verifying certificate...</p>
          </div>
        )}

        {status === "invalid" && (
          <div className="notification is-danger is-light has-text-centered mt-4">
            <span className="icon is-large">
              <i className="fa fa-times-circle fa-2x" />
            </span>
            <p className="is-size-5 has-text-weight-bold mt-2">
              Certificate Not Found
            </p>
            <p className="is-size-6 has-text-grey-dark mt-1">
              This certificate could not be verified. It may be invalid or
              expired.
            </p>
          </div>
        )}

        {status === "verified" && data && (
          <div
            className="card p-0"
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
              overflow: "hidden",
            }}
          >
            {/* Card header */}
            <div
              className="px-5 py-4 open-portel-background"
            
            >
              <p className="is-size-6 has-text-weight-semibold has-text-white-ter">
                Certificate Verification
              </p>
              {data.certificate_no && (
                <p className="is-size-7 mt-1" style={{ opacity: 0.8 }}>
                  Cert No: {data.certificate_no}
                </p>
              )}
            </div>

            {/* Certificate details */}
            <div className="card-content px-5 py-4">
              <table className="table is-fullwidth is-borderless" style={{ fontSize: "0.92rem" }}>
                <tbody>
                  <tr>
                    <td
                      className="has-text-weight-semibold has-text-grey-dark py-2 has-text-uppercase"
                      style={{ width: "38%", whiteSpace: "nowrap" }}
                    >
                      Name
                    </td>
                    <td className="py-2">
                      <span className="has-text-weight-medium has-text-uppercase open-portel-name">:</span>&nbsp;
                     <span className="open-portel-name">{data.ename}</span> 
                    </td>
                  </tr>
                        <tr>
                    <td className="has-text-weight-semibold has-text-grey-dark py-2">
                    Course
                    </td>
                    <td className="py-2">
                      <span className="has-text-weight-medium">:</span>&nbsp;
                      KAVACH Ver. 4.0 Training
                    </td>
                  </tr>
                  <tr>
                    <td className="has-text-weight-semibold has-text-grey-dark py-2">
                       Course Code
                    </td>
                    <td className="py-2">
                      <span className="has-text-weight-medium">:</span>&nbsp;
                      {data.session_label || data.course_name}
                    </td>
                  </tr>
                  {/* <tr>
                    <td className="has-text-weight-semibold has-text-grey-dark py-2">
                      Course Code
                    </td>
                    <td className="py-2">
                      <span className="has-text-weight-medium">:</span>&nbsp;
                      {data.course_code}
                    </td>
                  </tr> */}
                  <tr>
                    <td className="has-text-weight-semibold has-text-grey-dark py-2">
                      Date
                    </td>
                    <td className="py-2">
                      <span className="has-text-weight-medium">:</span>&nbsp;
                      {SdsDtChangeDateFormatTimeZone(data.session_date,"DD/MM/YYYY")} 
                    </td>
                  </tr>
                  {data.location && (
                    <tr>
                      <td className="has-text-weight-semibold has-text-grey-dark py-2">
                        Location
                      </td>
                      <td className="py-2">
                        <span className="has-text-weight-medium">:</span>&nbsp;
                        {data.loco_shed}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Verified stamp */}
              <div className="has-text-centered mt-4 mb-2">
                <div
                  style={{
                    display: "inline-block",
                    border: "3px solid #2d9e4f",
                    borderRadius: "6px",
                    padding: "6px 22px",
                    transform: "rotate(-5deg)",
                    color: "#2d9e4f",
                    fontWeight: "bold",
                    fontSize: "1.15rem",
                    letterSpacing: "3px",
                    opacity: 0.9,
                  }}
                >
                  <i className="fa fa-check-circle mr-2" />
                  VERIFIED
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateVerify;
